<template>
  <div class="container mx-auto text-center sm:text-center">
    <div class="mt-1">
      <div class=" flex flex-row justify-center">
        <input v-model="search" id="search" type="text" name="search" required class="w-2/6 border border-custom-blue1 px-3 py-2 rounded-lg shadow-sm focus:outline-none focus:border-custom-blue3 focus:ring-1 focus:ring-custom-blue2">
        <button @click="showWeather" class="transition ease-in-out duration-700 bg-custom-yellow1 hover:bg-custom-blue1 rounded-full text-base font-bold py-2 px-4 mx-3">
          <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6 items-center" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
          </svg>
        </button>
      </div>
    </div>
    <div class="container mx-auto">
      <Tarjeta :city="city" />
    </div>
  </div>
</template>

<script>
  import Tarjeta from "./Tarjeta.vue";
  import axios from "axios";
  export default {
    name: "Buscador",
    components: {
      Tarjeta,
    },
    data() {
      return {
        search: '',
        city: {
          name: '',
          temp: '',
          country: '',
          description: '',
          img: ''
        },
      }
    },
    methods: {
      /* sendData() {
        console.log(this.search);
        this.eventBus.emit('city', this.search);
        this.city = this.search;
        this.search = '';
      }, */
      capitalizeFirstLetter(str) {
        //return str.charAt(0).toUpperCase() + str.slice(1);
        return str.replace(/\b([a-zÁ-ú]{3,})/g, (w) => w.charAt(0).toUpperCase() + w.slice(1));
      },
      async showWeather() {
        this.search = this.capitalizeFirstLetter(this.search);
        this.city.name = this.search;
        //console.log('city name: '+this.city.name);
        this.search = '';
        const API_KEY = "269895404bcbee7df6ce760c64833484";
        const API_URL = `https://api.openweathermap.org/data/2.5/weather?q=${this.city.name}&units=metric&APPID=${API_KEY}`;
        axios.get(API_URL)
        .then(response => {
          this.city.temp = Math.round(response.data.main.temp).toString().concat(' ', '°C');
          //this.city.temp = this.city.temp.toString().concat(' ','°C');
          this.city.description = this.capitalizeFirstLetter(response.data.weather[0].description);
          this.city.country = this.capitalizeFirstLetter(response.data.sys.country);
          //this.city.img = "https://openweathermap.org/img/w/" + response.data.weather[0].icon.slice(0, 2) + ".png";
          this.city.img = `https://openweathermap.org/img/wn/${response.data.weather[0].icon}@2x.png`;
          console.log(`city name: ${this.city.name} with temp in c°: ${this.city.temp} and ${this.city.description} in ${this.city.country}`);
        }).catch( e =>{
            console.log(e);
        });
      },
    },
    
  };
</script>